import React, { FC } from 'react'

import { IconVirusProtectionProps } from './IconVirusProtection.types'
import * as Styled from './styles/IconVirusProtection.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVirusProtection: FC<IconVirusProtectionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVirusProtectionProps['size'],
  isResponsive = false,
}: IconVirusProtectionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m41.922 9.642-30.39 23.043' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M43.02 9.825c0 24.117-15.54 31.797-18.54 33.125a1.195 1.195 0 0 1-.98 0c-3-1.328-18.53-9-18.53-33.125 0-3.555 6.792 2.48 18.155-4.628a1.65 1.65 0 0 1 1.75 0C29.33 7.985 33.085 9.012 36 9.07h7.02v.755Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVirusProtection
